
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M123.648 178.347C361.643-98.603 802.987-43.947 967.936 279.68H571.435c-71.424 0-117.547-1.621-167.51 24.661-58.709 30.934-102.997 88.235-118.485 155.52L123.648 178.39z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M341.675 512c0 93.867 76.33 170.24 170.154 170.24 93.867 0 170.155-76.373 170.155-170.24s-76.33-170.24-170.155-170.24c-93.866 0-170.154 76.373-170.154 170.24z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M577.877 734.848c-95.53 28.373-207.274-3.115-268.501-108.8-46.763-80.64-170.24-295.765-226.347-393.557-196.565 301.226-27.136 711.808 329.686 781.866l165.12-279.509z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M669.867 341.76a233.13 233.13 0 0143.008 286.635c-40.576 69.973-170.155 288.682-232.96 394.581 367.658 22.656 635.733-337.664 514.645-681.259H669.867z","fill":"#FBBC05"}})])
          )
        }
      }
    